import styled from '@emotion/styled'
import {
  background, border, flexbox, layout, position, space,
} from 'styled-system'

const Line = styled.hr`
  display: flex;
  width: 100%;
  ${background}
  ${border}
  ${flexbox}
  ${layout}
  ${space}
  ${position}
`

Line.defaultProps = {
  borderColor: 'lineColor',
}

export default Line
